// @flow
import _ from 'lodash'
import React, { Component } from 'react'
import AdPreviewContainer from './AdPreviewContainer'
import type {
  AdvertisementStatistics,
  AdvertisementWithStoreId,
  AudienceData,
  Configs
} from '../types'
import ErrorText from '../controls/ErrorText'

export type Props = {|
  action: 'copy' | 'update' | 'create',
  advertisements: Array<AdvertisementWithStoreId>,
  statistics: { [number]: AdvertisementStatistics },
  disabledStoreIds: Array<string>,
  onToggle: Function,
  errors: Array<string>,
  disabled?: boolean,
  configs: Configs,
  audienceData: AudienceData,
  storeIds: Array<string> // eslint-disable-line react/no-unused-prop-types
|}

export default class AdsList extends Component<Props> {
  render() {
    const { disabledStoreIds, statistics, errors, configs, audienceData } = this.props

    return (
      <div>
        <ErrorText errors={errors} />
        {_.map(this.advertisements(), ({ storeId, ad }) => {
          return (
            <AdPreviewContainer
              action={this.props.action}
              key={storeId}
              providers={audienceData.providers}
              audienceType={audienceData.audienceType}
              statistics={statistics[ad.id || 0]}
              isDisabled={_.includes(disabledStoreIds, storeId)}
              onToggle={() => this.toggleAdvertisement(storeId)}
              checked={!_.includes(disabledStoreIds, storeId)}
              storeId={storeId}
              disabled={this.props.disabled}
              configs={configs}
              audienceData={audienceData}
            />
          )
        })}
      </div>
    )
  }

  advertisements(): Array<AdvertisementWithStoreId> {
    let result: Array<AdvertisementWithStoreId> = this.props.advertisements

    let stat: { [number]: AdvertisementStatistics } = this.props.statistics
    if (
      !_.some(
        _.map(result, (item) => item.ad.id),
        _.isUndefined
      )
    ) {
      // sort by CTR
      result.sort((a: AdvertisementWithStoreId, b: AdvertisementWithStoreId) => {
        const aId = a.ad.id
        const bId = b.ad.id
        if (aId && bId) {
          const aStat = stat[aId]
          const bStat = stat[bId]
          const aCtr = aStat && aStat.ctr
          const bCtr = bStat && bStat.ctr
          if (aCtr && bCtr) return bCtr - aCtr
          return aId - bId
        } else {
          return 0
        }
      })
    }

    return result
  }

  toggleAdvertisement(storeId: string) {
    const { onToggle } = this.props

    onToggle && onToggle(storeId)
  }
}
